import { useWindowDimensions } from 'react-native'
import QrReader from 'react-qr-scanner'
import { mobileAndTabletCheck } from '../../util/util'

interface props {
  onScan: (result: any) => void
  onError: (error: any) => void
}

const QrScanner = ({ onScan, onError }: props) => {
  const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = useWindowDimensions()
  const actualHeght = window.innerHeight ? window.innerHeight : SCREEN_HEIGHT

  const isMobileOrTablet = mobileAndTabletCheck()

  return (
    <QrReader
      facingMode={isMobileOrTablet ? 'rear' : undefined}
      style={{ objectFit: 'fill', width: SCREEN_WIDTH, height: SCREEN_HEIGHT, overFlow: 'hidden' }}
      onScan={onScan}
      onError={onError}
      legacyMode={true}
      delay={500}
      constraints={{
        video: {
          facingMode: { exact: isMobileOrTablet ? 'environment' : undefined },
          aspectRatio:
            SCREEN_HEIGHT > SCREEN_WIDTH ? `${SCREEN_HEIGHT / SCREEN_WIDTH}` : `${SCREEN_WIDTH / actualHeght}`,
        },
      }}
    />
  )
}

export { QrScanner }
